module.exports = __webpack_public_path__ + "media/VDOSolarTag2.5bfa3d7d.mp4";